import { Box, LinearProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import './Connection.css';

export default function ConnectionComponent(props: { sessionId: string; timeoutMs?: number; onTimeout?: () => void }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (!props.onTimeout) return;
    const t = setTimeout(() => props.onTimeout!(), props.timeoutMs ?? 20000);
    return () => clearTimeout(t);
  }, [props.onTimeout, props.timeoutMs]);

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
      <div className="connection">
        <h2>Conectando à sessão</h2>
        {/* <label>{props.sessionId}</label> */}
      </div>
    </>
  );
}
